import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SessionBridge } from "./components/SessionBridge";
import { AuthContextProvider } from "./lib/auth-context";
import { getAuth0RedirectUri } from "./lib/auth0-redirect";
import { SettingsProvider } from "./lib/settings-context";
import "./index.css";

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;

const rootTree = (
  <>
    {domain && clientId ? (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: getAuth0RedirectUri(),
        // Do not set `audience` here: Auth0 requires the SPA to be authorized for that API
        // (Dashboard → Application → APIs). Session exchange uses the default access token
        // whose `aud` is the SPA client id — see `oidc-verify.ts`.
        scope: "openid profile email offline_access",
      }}
      useRefreshTokens
      cacheLocation="localstorage"
    >
      <AuthContextProvider>
        <SettingsProvider>
          <SessionBridge />
          <App />
        </SettingsProvider>
      </AuthContextProvider>
    </Auth0Provider>
    ) : (
      <SettingsProvider>
        <App />
      </SettingsProvider>
    )}
  </>
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>{rootTree}</React.StrictMode>,
);
